import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "../../lib/api";
import { HC } from "../hr/theme";
import { DataTable, Pager, dt } from "./crmui";
import { toast } from "sonner";

const TYPES = ["", "registration", "verification", "purchase", "loyalty_earn", "loyalty_redeem",
  "loyalty_reversal", "loyalty_expiry", "tier_upgrade", "tier_downgrade", "campaign_enrollment",
  "campaign_interaction", "journey_enrollment", "journey_completion", "profile_update",
  "consent_change", "customer_merge", "order_refund", "loyalty_adjustment"];

export default function CustomerActivity() {
  const navigate = useNavigate();
  const [type, setType] = useState("");
  const [page, setPage] = useState(1);
  const [d, setD] = useState({ rows: [], total: 0 });

  const load = useCallback(() => {
    api.get("/crm/activity", { params: { page, page_size: 50, ...(type ? { event_type: type } : {}) } })
      .then(setD).catch((e) => toast.error(formatApiError(e)));
  }, [page, type]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-4" data-testid="crm-activity-page">
      <select value={type} onChange={(e) => { setType(e.target.value); setPage(1); }} data-testid="activity-type-filter"
        className="h-9 px-2 rounded-md border text-[12.5px]" style={{ borderColor: HC.border }}>
        {TYPES.map((t) => <option key={t} value={t}>{t ? t.replace(/_/g, " ") : "All event types"}</option>)}
      </select>
      <DataTable testid="crm-activity-table" rows={d.rows}
        columns={[["at", "When"], ["customer_name", "Customer"], ["event_type", "Event"], ["title", "Detail"],
                  ["source", "Source"], ["user_name", "By"]]}
        render={{ at: (r) => dt(r.at), event_type: (r) => r.event_type.replace(/_/g, " ") }}
        onRowClick={(r) => navigate(`/crm/customers/${r.customer_id}`)}
        empty="No customer activity recorded yet" />
      <Pager page={page} pageSize={50} total={d.total} onPage={setPage} testid="activity-pager" />
    </div>
  );
}
